
/**
 * Extracts user-friendly error message from country mutation errors
 */
export const extractCountryErrorMessage = (error: any): string => {
  // Handle Supabase error object
  if (error && typeof error === 'object') {
    if ('message' in error) {
      return error.message as string;
    }
    if ('details' in error) {
      // Check for unique constraint violations
      if (error.details?.includes('already exists')) {
        return "This country already exists in the database.";
      }
      return error.details as string;
    }
  }
  
  return "Failed to add country. Please try again.";
};
